const classForm = {
	state:{
		classId:[],
		classPrice:'',
		classPerson:false,//是否会员
		areaId:'',
		addressId:'',
	},
	getters:{
		classPerson:state => state.classPerson,
		areaId:state => state.areaId,
		addressId:state => state.addressId,
	},
	mutations:{
		setClassPerson(state,payload){
			state.classPerson = payload
		},
		setAreaId(state,payload){
			state.areaId = payload
		},
		setAddressId(state,payload){
			state.addressId = payload
		},
	}
}

export default classForm


// WEBPACK FOOTER //
// ./src/utils/store/module/classForm.js